import { type CSSProperties, useId, useMemo } from 'react';

import './WizardOverlay.css';
import type { SpotlightShape } from './types';

const WIZARD_OVERLAY_Z_INDEX = 10000;

type WizardOverlayProps = {
  spotlightShape: SpotlightShape;
};

const dimLayerClassName =
  'wizard-overlay-dim pointer-events-auto fixed inset-0 bg-gray-90/35 backdrop-blur-[6px]';

export default function WizardOverlay({ spotlightShape }: WizardOverlayProps) {
  const reactId = useId();
  const maskId = useMemo(
    () => `wizard-spotlight-mask-${reactId.replace(/:/g, '')}`,
    [reactId],
  );

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const { top, left, width, height, borderRadius } = spotlightShape;

  const dimLayerStyle = useMemo(
    (): CSSProperties => ({
      mask: `url(#${maskId})`,
      WebkitMask: `url(#${maskId})`,
      maskMode: 'luminance',
      maskRepeat: 'no-repeat',
      WebkitMaskRepeat: 'no-repeat',
    }),
    [maskId],
  );

  return (
    <div
      className="pointer-events-none fixed inset-0"
      style={{ zIndex: WIZARD_OVERLAY_Z_INDEX }}
      aria-hidden="true"
    >
      <svg aria-hidden="true" className="absolute size-0 overflow-hidden">
        <defs>
          <mask
            id={maskId}
            height={viewportHeight}
            maskContentUnits="userSpaceOnUse"
            maskUnits="userSpaceOnUse"
            width={viewportWidth}
            x="0"
            y="0"
          >
            <rect
              fill="white"
              height={viewportHeight}
              width={viewportWidth}
              x="0"
              y="0"
            />
            <rect
              fill="black"
              height={height}
              rx={borderRadius}
              ry={borderRadius}
              width={width}
              x={left}
              y={top}
            />
          </mask>
        </defs>
      </svg>
      <div className={dimLayerClassName} style={dimLayerStyle} />
    </div>
  );
}
